/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import LoginPage from "./pages/login";
import CompanyRegistration from "./pages/companyRegistration";
import UserRegistration from "./pages/user-registration";
import TNCPage from "./pages/tncPage";
import SetPasswordPage from "./pages/setPasswordPage";
import PageNotFound from "./pages/pageNotFound";
import Dashboard from "./pages/dashboard";
import Header from "./components/layout/header";
import Footer from "./components/layout/footer";
import ContinueRegistrationPage from "./pages/continueRegistrationPage";
import ResetPasswordPage from "./pages/resetPasswordPage";
import RoleRequestTabs from "./pages/RoleRequestTabs";
import { AuthLayout } from "./components/01-atoms/AccessGuardedRoute";
import MyProfile from "./pages/myProfile";
import InviteUser from "./pages/inviteUser";
import SAML from "./pages/saml";
import { UnProtectedContainer } from "./components/01-atoms/UnprotectedPageContainer";
import { UnProtectedContainerNoHF } from "./components/01-atoms/UnprotectedPageContainerNoHF";
import { UnprotectedPageContainerHeader } from "./components/01-atoms/UnprotectedPageContainerHeader";
import { UnprotectedPageContainerHeaderFooter } from "./components/01-atoms/UnprotectedPageContainerHeaderFooter";
import RedirectMFAPage from "./pages/RedirectMFA";
import LoginHelp from "./components/forms/Login/loginHelp";
import CreateAccount from "./components/forms/Login/CreateAccount";
import { appInsights } from "./appInsights/appInsights";
import InviteUserTabs from "./pages/inviteUsersTab";

function App() {
  const [isReady, setReady] = useState(false);

  useEffect(() => {
    appInsights.loadAppInsights();
    if (typeof window !== "undefined") {
      setReady(true);
    }
  }, []);

  if (isReady) {
    return (
      <>
        <BrowserRouter basename={"/identity"}>
          <Routes>
            <Route element={<UnProtectedContainerNoHF />}>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/redirectMFA" element={<RedirectMFAPage />} />
            </Route>

            <Route element={<UnprotectedPageContainerHeader />}>
              <Route path="/loginHelp" element={<LoginHelp />} />
              <Route path="/createAccount" element={<CreateAccount />} />
            </Route>

            <Route element={<UnprotectedPageContainerHeaderFooter />}>
              <Route path="/Resetpassword" element={<ResetPasswordPage />} />
            </Route>

            <Route element={<UnProtectedContainer />}>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/companyRegistration" element={<CompanyRegistration />} />
              <Route path="/userRegistration" element={<UserRegistration />} />
              <Route path="/tnc" element={<TNCPage />} />
              <Route path="/continueRegistration" element={<ContinueRegistrationPage />} />
              <Route path="/samlLogin" element={<SAML />} />
              <Route path="/Setpassword" element={<SetPasswordPage />} />
            </Route>

            /****put all service page here i.e pages to be displayed only
              after user loggin */
            <Route element={<AuthLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/myProfile" element={<MyProfile />} />
              <Route path="/roleRequest" element={<RoleRequestTabs />} />
              <Route path="inviteUser" element={<InviteUserTabs />} />
            </Route>

            <Route path="/pageNotFound" element={<PageNotFound />} />
            <Route path="*" element={<Navigate to="/pageNotFound" replace />} />
          </Routes>
        </BrowserRouter>
      </>
    );
  } else {
    return <></>;
  }
}

export default App;
